/**
 * Object Utility methods
 */
export const ObjectUtils = {
    /**
     * Deep merge two object recursively and return the resulting object
     *
     * @template {T extends Record<string, unknown>}
     * @param {T} obj1
     * @param {T} obj2
     * @return {T} object, object containing properties from obj1 and obj2
     */
    deepMerge: <T extends Record<string, unknown> = Record<string, unknown>>(
        obj1: T,
        obj2: T
    ): T => {
        if (!obj1) return obj2
        if (!obj2) return obj1
        const tempObj2 = JSON.parse(JSON.stringify(obj2))
        for (const key of Object.keys(tempObj2)) {
            if (tempObj2[key] instanceof Object)
                Object.assign(
                    tempObj2[key],
                    ObjectUtils.deepMerge(
                        key in obj1
                            ? (obj1[key] as Record<string, unknown>)
                            : {},
                        tempObj2[key]
                    )
                )
        }
        return { ...obj1, ...tempObj2 }
    },

    /**
     * Generate and returns a random alpha numeric
     *
     * @param {number} len - the length of generated alphanumeric string
     * @returns {string}
     */
    getAlphaNumericRandomGen: (len: number): string => {
        const chars =
            '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
        let str = ''
        while (str.length < len) {
            const rnum = Math.floor(Math.random() * chars.length)
            str += chars.substring(rnum, rnum + 1)
        }
        return str
    },

    /**
     * Converts key/value pairs object to key/value string
     *
     * @template {T}
     * @param {T} param - ex. {no_pol:true, page:index }
     * @param {string} delim
     * @param {string} divider
     * @returns {string}
     */
    convertKeyValuesToString: <T = Record<string, string>>(
        param: T,
        delim = '=',
        divider = '&'
    ): string => {
        const object = (param as unknown) as Record<string, string>
        return Object.keys(object)
            .map((key) => `${key}${delim}${object[key]}`)
            .join(`${divider}`)
    }
}
